import React from "react";
import { Row, Col, Form, Popover, Overlay, Table } from "react-bootstrap";
import $ from "jquery";
import StudentController from "../api/StudentController";
import { store } from "../redux/store/store";
export const globalStore = store;

interface PrivacySettingsViewState
{
    target: any;
    show: boolean | undefined;
    popOverData: any;
}

interface PrivacySettingsViewProps
{
    data: PrivacySettings;
    actions?: any;
}

class PrivacySettingsView extends React.Component<PrivacySettingsViewProps, PrivacySettingsViewState>
{
    studentController: StudentController;

    constructor(props: PrivacySettingsViewProps) 
    {
        super(props);
        this.studentController = new StudentController();
        this.state = { show: false, target: false, popOverData: null };
    }

    async onSettingClick(itm: PrivacySetting)
    {
        itm.isActive = !itm.isActive;
        await this.studentController.setPrivacySettings(itm);
    }

    render(): React.ReactNode 
    {
        const selectedAcademicItems =
            [
                {
                    "name": "Research Supervisor",
                    "message": "Show/Hide Research Supervisor information including name and contact information",
                    "items": []
                },
                {
                    "name": "Enrolled Assignments, Quiz and Exams",
                    "message": "Show/Hide:",
                    "items": ["Subject Location", "Enrolled Assignment names and dates", "Enrolled Exam dates", "Lecture Times", "Recitation Times", "Teaching Assistant"]
                },
                {
                    "name": "MITSI",
                    "message": "Show/Hide Current and Historic MISTI related program information",
                    "items": []
                },
                {
                    "name": "FPOP",
                    "message": "Show/Hide Current and Historic FPOP related program information",
                    "items": []
                },
                {
                    "name": "UROP",
                    "message": "Show/Hide Current and Historic UROP related program information",
                    "items": []
                },
                {
                    "name": "Previous School",
                    "message": "Show/Hide Previous School related information",
                    "items": []
                }
            ];

        const selectedContactItems =
            [
                {
                    "name": "Address (Home & Office)",
                    "message": "Show/Hide:",
                    "items": ["Home (Current and Previous)", "Office (Current and Previous)"]
                },
                {
                    "name": "Roommates names",
                    "message": "Show/Hide Roommate Names",
                    "items": []
                }
            ];

        const selectedStudentLifeItems =
            [
                {
                    "name": "Student Life",
                    "message": "Show/Hide Student Life related information:",
                    "items": ["Varsity Athletics", "Greek Membership", "ILG Membership", "Student Activities"]
                },
                {
                    "name": "Student Finances",
                    "message": "Show/Hide Student Finances related information:",
                    "items": ["Financial Aid", "TA/RA Appointments", "Work Study Hours"]
                }
            ];

        const academicItems = this.props.data.privacySettings.filter(itm => itm.settingName.toLowerCase().includes("academic"));
        const contactItems = this.props.data.privacySettings.filter(itm => itm.settingName.toLowerCase().includes("contact"));
        const studentLifeItems = this.props.data.privacySettings.filter(itm => itm.settingName.toLowerCase().includes("student life") || itm.settingName.toLowerCase().includes("student finances"));

        const onMouseOver = (itm: any, event: any): void => 
        {
            const tr = $(event.target).parent("div");

            if (tr) 
            {
                this.setState({ show: true, target: tr[0], popOverData: itm });
            }
        };

        const onMouseOut = (): void => 
        {
            this.setState({ show: false, target: this.state.target });
        };

        return <div className="m-3">
            {
                this.state.popOverData
                &&
                <Overlay
                    show={this.state.show}
                    target={this.state.target}
                    placement="right"
                >
                    <Popover {...this.props} id="popover-contained" className="popover">
                        <Popover.Content aria-expanded={"true"} aria-live={"polite"}>
                            <Table borderless>
                                <tbody>
                                    <tr>
                                        <td><b aria-label={"Test"}>{this.state.popOverData.name}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.popOverData.message}</td>
                                    </tr>
                                    {
                                        this.state.popOverData.items.length > 0
                                        &&
                                        <tr>
                                            <td>
                                                <ul>{
                                                    this.state.popOverData.items.map((itm, i) =>
                                                    {
                                                        return <li key={i}>{itm}</li>;
                                                    })
                                                }
                                                </ul>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </Popover.Content>
                    </Popover>
                </Overlay>
            }
            <Row className="justify-content-md-center">
                <Col lg={6}>
                    <h3>Academic</h3>
                    {
                        academicItems.map((privacySetting: PrivacySetting, i: number) => 
                        {
                            return <Row style={{ alignItems: "center" }} key={i}>
                                <Col xs={10}>
                                    <Form>
                                        <Form.Check>
                                            <Form.Check.Label aria-label={privacySetting.settingName} className={"container-checkbox"}>{privacySetting.settingName.replace("Academic - ", "")}
                                                <Form.Check.Input onChange={() => this.onSettingClick(privacySetting)} defaultChecked={privacySetting.isActive} />
                                                <span className={"checkmark"}></span>
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </Form>
                                </Col>
                                <Col onMouseOver={(e): void => onMouseOver(selectedAcademicItems[i], e)} onMouseOut={onMouseOut} xs={2}><i className={"fas fa-info-circle float-right"}></i></Col>
                            </Row>;
                        })
                    }
                    <h3>Contact</h3>
                    {
                        contactItems.map((privacySetting: PrivacySetting, i: number) => 
                        {
                            return <Row style={{ alignItems: "center" }} key={i}>
                                <Col xs={10}>
                                    <Form>
                                        <Form.Check>
                                            <Form.Check.Label aria-label={privacySetting.settingName} className={"container-checkbox"}>{privacySetting.settingName.replace("Contact - ", "")}
                                                <Form.Check.Input onChange={() => this.onSettingClick(privacySetting)} defaultChecked={privacySetting.isActive} />
                                                <span className={"checkmark"}></span>
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </Form>
                                </Col>
                                <Col xs={2} onMouseOver={(e): void => onMouseOver(selectedContactItems[i], e)} onMouseOut={onMouseOut}><i className={"fas fa-info-circle float-right"}></i></Col>
                            </Row>;
                        })
                    }
                    <h3>Student Life</h3>
                    {
                        studentLifeItems.map((privacySetting: PrivacySetting, i: number) => 
                        {
                            return <Row style={{ alignItems: "center" }} key={i}>
                                <Col xs={10}>
                                    <Form>
                                        <Form.Check>
                                            <Form.Check.Label aria-label={privacySetting.settingName} className={"container-checkbox"}>{privacySetting.settingName.split("(")[0]}
                                                <Form.Check.Input onChange={() => this.onSettingClick(privacySetting)} defaultChecked={privacySetting.isActive} />
                                                <span className={"checkmark"}></span>
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </Form>
                                </Col>
                                <Col xs={2} onMouseOver={(e): void => onMouseOver(selectedStudentLifeItems[i], e)} onMouseOut={onMouseOut}><i className={"fas fa-info-circle float-right"}></i></Col>
                            </Row>;
                        })
                    }
                </Col>
                <Col lg={6}>
                    <p>Privacy Settings will give you the ability to show/hide your profile information to your <b>Academic Advisors</b>.</p>

                    <p>Each selected privacy setting hides or displays a whole set of fields related to the selected setting. To view which fields are related to the setting, simply hover over settings to the left.</p>

                    <p>Guide:</p>
                    <Form>
                        <Form.Check>
                            <Form.Check.Label className={"container-checkbox"}>Show information
                                    <Form.Check.Input defaultChecked={false} disabled />
                                <span className={"checkmark"}></span>
                            </Form.Check.Label>
                        </Form.Check>
                    </Form>
                    <Form>
                        <Form.Check>
                            <Form.Check.Label className={"container-checkbox"}>Hide information
                                    <Form.Check.Input defaultChecked={true} disabled />
                                <span className={"checkmark"}></span>
                            </Form.Check.Label>
                        </Form.Check>
                    </Form>


                    <p>By default all options are set to hidden.</p>
                </Col>
            </Row>
        </div>;
    }
}

export default PrivacySettingsView;